export default __webpack_public_path__ + "static/media/complementary--chevron-left--g1.57ac3093.png";